/* tslint:disable */
import {
  ProductUom,
  Product,
  ResiduePartnerKpiType
} from '../index';

declare var Object: any;
export interface ResiduePartnerKPIInterface {
  "id"?: number;
  "name"?: string;
  "description"?: string;
  "more_info"?: string;
  "formula"?: number;
  "type"?: number;
  "uom_id"?: number;
  "partner_id"?: number;
  "company_id"?: number;
  "chart_type"?: string;
  "product_id"?: number;
  uom?: ProductUom;
  product?: Product;
  typeName?: ResiduePartnerKpiType;
}

export class ResiduePartnerKPI implements ResiduePartnerKPIInterface {
  "id": number;
  "name": string;
  "description": string;
  "more_info": string;
  "formula": number;
  "type": number;
  "uom_id": number;
  "partner_id": number;
  "company_id": number;
  "chart_type": string;
  "product_id": number;
  uom: ProductUom;
  product: Product;
  typeName: ResiduePartnerKpiType;
  constructor(data?: ResiduePartnerKPIInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ResiduePartnerKPI`.
   */
  public static getModelName() {
    return "ResiduePartnerKPI";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ResiduePartnerKPI for dynamic purposes.
  **/
  public static factory(data: ResiduePartnerKPIInterface): ResiduePartnerKPI{
    return new ResiduePartnerKPI(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ResiduePartnerKPI',
      plural: 'ResiduePartnerKPIs',
      path: 'ResiduePartnerKPIs',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "more_info": {
          name: 'more_info',
          type: 'string'
        },
        "formula": {
          name: 'formula',
          type: 'number'
        },
        "type": {
          name: 'type',
          type: 'number'
        },
        "uom_id": {
          name: 'uom_id',
          type: 'number'
        },
        "partner_id": {
          name: 'partner_id',
          type: 'number'
        },
        "company_id": {
          name: 'company_id',
          type: 'number'
        },
        "chart_type": {
          name: 'chart_type',
          type: 'string'
        },
        "product_id": {
          name: 'product_id',
          type: 'number'
        },
      },
      relations: {
        uom: {
          name: 'uom',
          type: 'ProductUom',
          model: 'ProductUom',
          relationType: 'belongsTo',
                  keyFrom: 'uom_id',
          keyTo: 'id'
        },
        product: {
          name: 'product',
          type: 'Product',
          model: 'Product',
          relationType: 'belongsTo',
                  keyFrom: 'product_id',
          keyTo: 'id'
        },
        typeName: {
          name: 'typeName',
          type: 'ResiduePartnerKpiType',
          model: 'ResiduePartnerKpiType',
          relationType: 'belongsTo',
                  keyFrom: 'type',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ResiduePartnerKPI.ts